import { CreateBatchInfo, IBatch, IqueryParams } from "../../config/types";
import { buildQueryString } from "../../utils/buildQueryString";
import { apiService } from "../api.service";

interface ExportParams extends IqueryParams<{
  batch_domain?: string;
  received_date?: string;
  donor?: string;
}> {
  file_format: 'pdf' | 'csv';
}

const createBatch = async (data: CreateBatchInfo) => {
  return apiService.apiRequest<CreateBatchInfo>("post", `batches`, data);
};

const getBatches = async (queryParams?: IqueryParams<{
  batch_domain?: string;
  received_date?: string;
  donor?: string;
}>) => {
  const query = buildQueryString(queryParams);
  return apiService.apiRequest<IBatch[]>("get", `/batches${query}`);
};

const getBatch = async (batch_id: string) => {
  return apiService.apiRequest<IBatch>("get", `batches/${batch_id}`);
};

const updateBatch = async (batch_id: string, data: Partial<CreateBatchInfo>) => {
  return apiService.apiRequest<IBatch>("put", `batches/${batch_id}`, data);
};

const deleteBatch = async (batch_id: string) => {
  return apiService.apiRequest<any>("delete", `batches/${batch_id}`);
};

const restoreBatch = async (batch_id: string, data: Partial<CreateBatchInfo>) => {
  return apiService.apiRequest<IBatch>("put", `batches/${batch_id}/restore`, data);
};

const exportBatches = async (params: ExportParams) => {
  const { page, page_size, ...exportParams } = params;
  const query = buildQueryString(exportParams);

  return apiService.apiRequest<{ download_url: string }>(
    "get",
    `batches/export${query}`
  );
};

export const batchApi = {
  createBatch,
  getBatches,
  getBatch,
  deleteBatch,
  restoreBatch,
  updateBatch,
  exportBatches,
};